import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import UnitInfo from '../UnitInfo';


const UnitInfoContainer = ({ unit }) => (
  <div className="booking-phase-centered-content booking-unit-info-section">
    <div className="unit-info-content">
      <UnitInfo unit={unit} />
    </div>
  </div>
);

UnitInfoContainer.propTypes = {
  unit: PropTypes.shape({})
};

UnitInfoContainer.defaultProps = {
  unit: {}
};

export default translate(['booking'])(UnitInfoContainer);



// WEBPACK FOOTER //
// ./src/containers/Booking/UnitInfoContainer.jsx